// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import dataTableStyles from "@awc/App/SharedStyles/MyAccountPages/List/DataTableStyles";
import { ellipsis } from "@awc/XDL/Utilities";
import { orderHistoryTableStyles } from "@insite/content-library/Widgets/OrderHistory/OrderHistoryTable";
import RefreshCcw from "@insite/mobius/Icons/RefreshCcw";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

orderHistoryTableStyles.reorderButton = {
    variant: "link" as any,
    icon: {
        src: RefreshCcw,
        position: "left",
    },
    css: css`
        margin-left: auto;
    `,
};

orderHistoryTableStyles.reorderButtonSpinner = {
    size: 16,
    css: css`
        margin-left: auto;
        margin-right: auto;
        display: block;
    `,
};

orderHistoryTableStyles.dataTable = {
    ...dataTableStyles.dataTable,
};

orderHistoryTableStyles.noResultsContainer = {
    ...dataTableStyles.noResultsContainer,
};

orderHistoryTableStyles.noResultsText = {
    ...dataTableStyles.noResultsText,
};

orderHistoryTableStyles.orderNumberHeader = {
    tight: true,
};

orderHistoryTableStyles.orderDateHeader = {
    tight: true,
};

orderHistoryTableStyles.statusHeader = {
    tight: true,
};

orderHistoryTableStyles.customerPOHeader = {
    tight: true,
};

orderHistoryTableStyles.reorderHeader = {
    tight: true,
};

orderHistoryTableStyles.shipToHeader = {
    tight: true,
};

orderHistoryTableStyles.orderTotalHeader = {
    tight: true,
};

orderHistoryTableStyles.shipToCells = {
    css: css`
        max-width: 400px;
        min-width: 250px;
        white-space: normal;
        > ${TypographyStyle} {
            ${ellipsis(1)}
        }
    `,
};

orderHistoryTableStyles.orderTotalCells = {
    alignX: "left",
};
